import get from 'lodash/get';
import { StepListFilterType } from '@xmatters/common/constants/scriptSteps';

import persistState from './creators/persistState';

export default persistState({
  key: 'xm.flowDesigner',
  slicer: state => ({
    flowDesignerPreferences: {
      dismissDragHintOnPropertySidePanel: get(
        state,
        'flowDesignerPreferences.dismissDragHintOnPropertySidePanel',
        null,
      ),
      callableFlowListFilterType: get(
        state,
        'flowDesignerPreferences.callableFlowListFilterType',
        StepListFilterType.ALL,
      ),
      customHttpTriggerListFilterType: get(
        state,
        'flowDesignerPreferences.customHttpTriggerListFilterType',
        StepListFilterType.ALL,
      ),
      customStepListFilterType: get(
        state,
        'flowDesignerPreferences.customStepListFilterType',
        StepListFilterType.ALL,
      ),
    },
  }),
});
